import KioskCreationDefinitionBusiness from './KioskCreationDefinitionBusiness'
export default KioskCreationDefinitionBusiness
